
import configCard from './config-card.vue';

export default {
  components: {
    configCard: configCard
  },

  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      formItemList: [{
        label: '是否通过代码字实现：',
        type: 'plain-text',
        prop: 'enable_i18n'
      }]
    };
  },


  computed: {
    formValue: function formValue() {
      var text = '-';

      if (this.schemeValue.enable_i18n === 1) text = '是';else if (this.schemeValue.enable_i18n === 2) text = '否';else text = '否';

      return {
        enable_i18n: text
      };
    }
  },

  methods: {}
};